var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "users",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.495,
    height: 38.796,
    viewBox: "0 0 48.495 38.796",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4506",
    "data-name": "Path 4506",
    d: "M142.549,142.549a7.274,7.274,0,1,0-7.274-7.274A7.274,7.274,0,0,0,142.549,142.549Zm-4.448,2.425a10.1,10.1,0,0,0-10.1,10.1,2.023,2.023,0,0,0,2.023,2.023h25.051a2.023,2.023,0,0,0,2.023-2.023,10.1,10.1,0,0,0-10.1-10.1Z",
    transform: "translate(-118.301 -118.301)",
    fill: "#047BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4507",
    "data-name": "Path 4507",
    d: "M16.973,6.062a6.062,6.062,0,1,0-6.062,6.062,6.062,6.062,0,0,0,6.062-6.062Zm27.885,0A6.062,6.062,0,1,0,38.8,12.124a6.062,6.062,0,0,0,6.062-6.062ZM8.085,14.549A8.088,8.088,0,0,0,0,22.634a1.62,1.62,0,0,0,1.614,1.614H17.837a9.676,9.676,0,0,1-3.281-7.274,10.378,10.378,0,0,1,.144-1.69,8.011,8.011,0,0,0-3.38-.735Zm22.581,9.7H46.881A1.615,1.615,0,0,0,48.5,22.634a8.088,8.088,0,0,0-8.085-8.085H37.182a8.128,8.128,0,0,0-3.38.735,9.536,9.536,0,0,1,.144,1.69A9.7,9.7,0,0,1,30.666,24.248Z",
    fill: "#888",
    opacity: 0.4
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users.d2b4265d8cc0d4aa0ca1a3d3b2c20a70.svg";